"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditPageSchema = exports.AuditQuerySchema = exports.AuditLogRowSchema = exports.SECURITY_ACTIONS = exports.AuditActionSchema = exports.AUDIT_ACTIONS = void 0;
exports.isSecurityAction = isSecurityAction;
const zod_1 = require("zod");
const query_1 = require("./query");
/**
 * Nhật ký kiểm toán — PRS §11.3, spec SC-12.
 *
 * Chỉ ghi thêm, không sửa, không xoá. Không có endpoint nào cập nhật hay xoá một
 * dòng, và cố ý không được thêm.
 */
/**
 * Mã hành động. Dạng `<nhóm>.<việc>` để lọc theo nhóm bằng tiền tố.
 *
 * Chỉ ghi hành động LÀM ĐỔI TRẠNG THÁI. Thao tác đọc (mở màn, xem báo cáo) không
 * ghi: khối lượng lớn mà giá trị thấp ở quy mô này, và làm loãng đúng những dòng
 * cần tìm khi có sự cố.
 */
exports.AUDIT_ACTIONS = [
    // Tài khoản
    'auth.login.success',
    'auth.login.failed',
    'auth.login.locked',
    'auth.logout',
    'auth.password.changed',
    'user.created',
    'user.updated',
    'user.password.reset',
    // Trang
    'page.created',
    'page.renamed',
    'page.deleted',
    'page.restored',
    'page.owner.changed',
    'page.invariants.changed',
    /**
     * Bật/tắt quét lại hàng tuần cho một trang (spec SC-08 §4.2).
     *
     * Ghi vì đây là câu trả lời cho "sao trang này mấy tháng nay không thấy quét
     * nữa" — một câu hỏi mà không có dòng này thì phải đi hỏi từng người.
     */
    'page.weekly-rescan.changed',
    // Quét
    'scan.one',
    'scan.all',
    /**
     * Đo tốc độ thật (spec SC-18). Ghi vì đây là lời gọi ra DỊCH VỤ NGOÀI có hạn
     * mức dùng chung — khi hết hạn mức trong ngày, đây là chỗ duy nhất trả lời được
     * "ai đã tiêu hết".
     */
    'speed.measured',
    /**
     * Đổi một thiết lập dùng chung — hiện chỉ có ngưỡng sinh cảnh báo (spec SC-08 §5).
     *
     * Ghi vì đây là giá trị ảnh hưởng tới MỌI người: hạ ngưỡng xuống 1 là cả đội bị
     * dội cảnh báo, nâng lên 100 là không ai nhận được gì nữa. Cả hai đều dẫn tới
     * câu hỏi "ai đổi, đổi lúc nào", và không có dòng này thì không trả lời được.
     */
    'setting.changed',
];
exports.AuditActionSchema = zod_1.z.enum(exports.AUDIT_ACTIONS);
/**
 * Hành động liên quan bảo mật — giữ 24 tháng thay vì 12 (spec SC-12 §6).
 * Đây là những dòng cần tới khi điều tra sự cố, tức là lúc người ta nhìn xa nhất
 * về quá khứ.
 */
exports.SECURITY_ACTIONS = [
    'auth.login.failed',
    'auth.login.locked',
    'auth.password.changed',
    'user.password.reset',
    'user.updated',
];
function isSecurityAction(action) {
    return exports.SECURITY_ACTIONS.includes(action);
}
exports.AuditLogRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    action: exports.AuditActionSchema,
    createdAt: zod_1.z.coerce.date(),
    /** Người thực hiện; null với hành động của người chưa đăng nhập được */
    actorId: zod_1.z.number().int().nullable(),
    actorName: zod_1.z.string().nullable(),
    actorEmail: zod_1.z.string().nullable(),
    /** Người BỊ tác động, để tra "ai đã đụng vào tài khoản này" */
    targetUserId: zod_1.z.number().int().nullable(),
    targetUserName: zod_1.z.string().nullable(),
    pageSlug: zod_1.z.string().nullable(),
    ip: zod_1.z.string().nullable(),
    userAgent: zod_1.z.string().nullable(),
    /** Chi tiết theo từng loại hành động — vai trò cũ → mới, luật nào bật/tắt… */
    detail: zod_1.z.record(zod_1.z.unknown()),
});
/**
 * Bộ lọc màn nhật ký. Phân trang PHÍA SERVER: bảng này lớn nhanh nhất hệ thống,
 * kéo hết về trình duyệt là hỏng ngay trong tháng đầu.
 */
exports.AuditQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    actorId: zod_1.z.coerce.number().int().positive().optional(),
    action: exports.AuditActionSchema.optional(),
    pageSlug: zod_1.z.string().min(1).optional(),
    /** ISO 8601 */
    from: zod_1.z.coerce.date().optional(),
    to: zod_1.z.coerce.date().optional(),
    /**
     * Ô tìm nhanh "các lần đăng nhập thất bại 24 giờ qua" — dùng nhiều nhất khi nghi
     * có người dò mật khẩu, nên làm hẳn một cờ thay vì bắt người trực tự dựng bộ lọc.
     */
    failedLoginsOnly: query_1.QueryBooleanSchema.optional(),
});
exports.AuditPageSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.AuditLogRowSchema),
    total: zod_1.z.number().int(),
    page: zod_1.z.number().int(),
    pageSize: zod_1.z.number().int(),
});
//# sourceMappingURL=audit.js.map